const validSpecialChars = {
  '\\*': '*',
  '\\.': '.',
  '\\(': '(',
  '\\)': ')',
  '\\+': '+',
};

const replaceSpecialChars = text =>
  Object.entries(validSpecialChars).reduce((text, [syn, char]) => text.replaceAll(char, syn), text);

export default (text, highlight) => {
  const highlightWords = highlight
    .split(' ')
    .filter(s => s.length > 0)
    .sort((a, b) => b.length - a.length);

  const validWords = highlightWords.map(s => replaceSpecialChars(s)).filter(s => s !== '');
  if (validWords.length === 0) return text;

  const textArr = text.split(' ');
  const highlightedArr = textArr.map(t =>
    t.replace(
      new RegExp(`(^|\\.)(${validWords.join('|')})`, 'gi'),
      '<span class="bg-amber-200">$&</span>',
    ),
  );
  return highlightedArr.join(' ');
};
